import { Button, Link } from '@chakra-ui/react';
import { FaWhatsapp } from 'react-icons/fa';
import { useTheme } from '../../contexts/ThemeProvider';

export function WhatsappFloatingBall() {
  const { isApp, cellphone, name } = useTheme();
  if (isApp) return <></>;
  const cleanedCellphone = (cellphone || '').replace(/\D/g, '');

  return (
    <Link
      pos={'fixed'}
      bottom={'80px'}
      target="_blank"
      right={'20px'}
      zIndex={999}
      href={`https://api.whatsapp.com/send?phone=${
        cellphone && cellphone !== '' ? `55${cleanedCellphone}` : '553184131003'
      }&text=Olá,%20gostaria%20de%20falar%20com%20a%20${cleanedCellphone ? name : 'Partiu'}!`}
    >
      <Button
        height={'60px'}
        width={'60px'}
        borderRadius={'100px'}
        backgroundColor={'rgb(56, 161, 105)'}
        colorScheme="green"
      >
        <FaWhatsapp size={'50px'} />
      </Button>
    </Link>
  );
}
